import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmInputComponent } from './sm-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SmErrorModule } from '../sm-error/sm-error.module';
import { TrimDirective } from 'common/helpers/sm-trim';
import { NgbPopover, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [SmInputComponent, TrimDirective],
    imports: [CommonModule,ReactiveFormsModule,FormsModule, SmErrorModule, NgbPopover],
    exports: [SmInputComponent]
})
export class  SmInputModule {}
